// Global dismiss signal for celebration emotes — overlay emotes are
// position:fixed, so when the route advances mid-animation the exiting screen
// leaves its emote playing on top of the NEXT screen; navigation dispatches
// this and every mounted EmoteOverlay fades out fast.
//
// Lives in its own tiny module so the app shell (App.jsx) can dispatch it
// WITHOUT importing emoteSystem.jsx — that module pulls gsap plus every emote
// WebP at module scope, which dragged them all into the shell bundle on '/'
// (perf audit 2026-07-14). emoteSystem re-exports these for existing callers.
export const emoteDismissTarget = new EventTarget();

export function dismissActiveEmotes() {
  emoteDismissTarget.dispatchEvent(new Event('emote-dismiss'));
}
